function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 19.5,
  stroke: "#230CAE",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, React.createElement("path", {
  d: "M187 80.99h36.236c22.154 0 37.46-15.314 37.46-35.292 0-20.181-15.306-35.698-37.46-35.698H203.5"
}), React.createElement("path", {
  d: "M10 13.91L32.586 81.5l25.03-66.9 25.027 66.9 18.932-54.093c2.694-7.885 8.34-14.442 16.286-16.607a22.576 22.576 0 0 1 15.693 1.413 23.004 23.004 0 0 1 6.536 4.681l.802.82.802-.82c4.317-4.402 10.17-6.875 16.272-6.875 6.103 0 11.956 2.473 16.273 6.875 4.33 4.405 6.761 10.39 6.758 16.633-.006 6.238-2.447 12.221-6.78 16.62l-.801.82-20.716 21.17-6.94 7.086a6.82 6.82 0 0 1-9.762 0l-2.134-2.195-4.812-4.914-11.64-11.892",
  strokeLinejoin: "round"
}));

var SvgWelovedevs = function SvgWelovedevs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "clogo-0-2-221",
    width: 271,
    height: 92,
    viewBox: "0 0 271 92",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWelovedevs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welovedevs.21e1fe05.svg";
export { ForwardRef as ReactComponent };